import React from "react";

import FlightsPlaceholderImage from "../../../images/flights.png";
import StudentUniverse from "../../../images/StudentUniverse.png";
import { Link } from "../../../utils/customLink";
import Image from "../../image";

const Flights = ({ flights }) => {
  return (
    <>
      <div className={""}>
        <h2 className="heading text-left pt-8 pb-5">{flights.flightsLabel}</h2>
        <div
          className={
            "text-std-med sm:text-xl font-alice dark:font-body font-light text-generic-text dark:text-white sm:w-full pt-2"
          }
          dangerouslySetInnerHTML={{
            __html: flights?.flightsSubtitle ?? ""
          }}
        />

        <div
          className={
            "text-xs font-body text-black-lighter dark:text-gray-generic my-4 pl-2 border-l-[2px] border-l-red-light dark:border-l-green-standard"
          }
          dangerouslySetInnerHTML={{
            __html: flights?.flightsFeeText ?? ""
          }}
        />

        <div className="flex flex-row w-full gap-2 pt-4">
          <div className="col-span-2 relative w-full sm:max-h-64 overflow-hidden rounded-sm">
            <Image
              sourceUrl={
                flights?.flightsImage?.sourceUrl ?? FlightsPlaceholderImage
              }
              imageAlt={""}
              image={""}
              imageClass="w-full h-full object-cover"
            />
          </div>
          <div className="col-span-1 flex items-center justify-center bg-gray-lighten dark:bg-black w-full sm:w-40 sm:max-h-64 px-4 rounded-sm">
            <Image
              sourceUrl={
                flights?.flightsStudentUniverseImg?.sourceUrl ?? StudentUniverse
              }
              imageAlt={""}
              image={""}
              imageClass="relative w-full sm:h-4"
            />
          </div>
        </div>

        <div
          className={
            "dark:gvi-light-gray-text text-black-lighter text-sm tab-content_html py-4"
          }
          dangerouslySetInnerHTML={{
            __html: flights.flightsDetails
          }}
        />

        <Link
          to={flights.flightsLink}
          target="_gviblank"
          className="flex w-full sm:w-64 items-center justify-center px-4 py-2 my-4 text-base border rounded-full !text-generic-text dark:!text-white hover:!text-white dark:hover:text-gray-darker border-generic-text dark:border-white dark:rounded-sm dark:hover:bg-white hover:bg-black-lighter leading-[22px] font-bold dark:hover:!text-black-lighter"
        >
          {flights.flightsLinkLabel}
        </Link>

        <div
          className={
            "dark:text-gray-generic text-black-lighter text-sm tab-content_html py-4"
          }
          dangerouslySetInnerHTML={{
            __html: flights.flightsStudentUniverseDetails
          }}
        />
      </div>
    </>
  );
};

export default Flights;
